export default __webpack_public_path__ + "static/media/ic-more.3f6e1b6f.svg";